import { types } from './types';

export const setGetExchangeRatesAction = (payload) => {
  return {
    type: types.SET_GET_EXCHANGE_RATES,
    payload,
  }
}